import React from "react";
import { Editor as TinyEditor } from "@tinymce/tinymce-react";

export default function TinyView({ value }) {
  return (
    <TinyEditor
      apiKey="utrrpdh2idboibxbi3j835hgnbd2om68gq18mifwf95hysdi"
      value={value}
      // init={{
      //   setup: function (editor) {
      //     editor.setMode("readonly");
      //   },
      //   inline: true,
      //   plugins: "autoresize",
      //   toolbar: false,
      //   menubar: false,
      //   statusbar: false,
      //   inline_boundaries: false,
      // }}
      init={{
        // toolbar_sticky: true,
        setup: function (editor) {
          editor.setMode("readonly");
        },
        selector: "textarea",
        // inline: true,
        // readonly: true,
        inline_boundaries: false,
        toolbar: false,
        menubar: false,
        statusbar: false,
        readonly: 1,
        plugins: "code noneditable autoresize",
        // [19:14, 7/25/2021] Zaeem Bro:
        browser_spellcheck: false,
        // [19:27, 7/25/2021] Zaeem Bro: plugins: "code noneditable autoresize",
        autoresize_top_margin: 1,
        autoresize_bottom_margin: 1,
        // autosave_ask_before_unload: true,
        // autosave_interval: "30s",
        // autosave_prefix: "{path}{query}-{id}-",
        // autosave_restore_when_empty: false,
        // autosave_retention: "2m",
        // image_advtab: true,

        // paste_word_valid_elements:
        //   "b,strong,i,em,h1,h2,u,p,ol,ul,li,a[href],span,color,font-size,font-color,font-family,mark",
        // paste_retain_style_properties: "all",
        table_sizing_mode: "relative",

        importcss_append: true,

        height: 100,
        // quickbars_selection_toolbar:
        //   "bold italic | quicklink h2 h3 blockquote quickimage quicktable",
        noneditable_noneditable_class: "mceNonEditable",
        // toolbar_mode: "sliding",
        // contextmenu: "link image imagetools table",
        skin: "oxide",
        content_css: "default",
        image_dimensions: true,

        cleanup_on_startup: true,
        // fix_list_elements : false,
        // fix_nesting : false,
        // fix_table_elements : false,
        // paste_use_dialog : true,
        // paste_auto_cleanup_on_paste : true,
        // plugins: "paste",
        // paste_as_text: true
      }}
    />
  );
}
